import { IconProps, NocIconGenerator } from '../common';

export const Sauna = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Sauna',
            path: (
                <path
                    d="M3 18.0268H14.5071M16.3639 3.00213C15.8939 3.40284 15.5939 3.91375 15.5039 4.47475C15.5939 5.02573 15.9039 5.54666 16.3639 5.94738M16.3639 8.85255C16.8339 8.45184 17.1339 7.94093 17.2239 7.37993C17.1339 6.82895 16.8239 6.30802 16.3639 5.9073M20.25 4C19.8401 4.25731 19.5785 4.58538 19.5 4.94561C19.5785 5.2994 19.8488 5.6339 20.25 5.89121M20.25 7.75669C20.6599 7.49939 20.9215 7.17132 21 6.81109C20.9215 6.45729 20.6512 6.12279 20.25 5.86548M6 6.00535C6 7.6583 7.335 9.01071 9 9.01071C10.665 9.01071 12 7.67333 12 6.00535C12 4.33738 10.65 3 9 3C7.35 3 6 4.35241 6 6.00535ZM18.84 20.0303L16.58 15.8429C16.12 14.9914 15.22 14.4604 14.25 14.4604H11.66L10.1 10.8239C9.81 10.1527 9.03 9.84219 8.36 10.1327C8.16 10.2229 7.99 10.3531 7.85 10.5234L4.33 14.9613C3.84 15.5123 3.89 16.3538 4.43 16.8447C4.97 17.3355 5.81 17.2855 6.3 16.7445C6.33 16.7044 6.36 16.6744 6.39 16.6343L8.10996 14.4604L9.20765 16.8447C9.46765 17.4157 10.6256 17.8765 11.2456 17.7763C11.7356 17.7763 14.59 17.2855 14.59 17.7763L16.52 21.3227C16.87 21.9438 17.65 22.1842 18.28 21.8536C18.92 21.523 19.18 20.7216 18.85 20.0704C18.85 20.0704 18.85 20.0604 18.84 20.0504V20.0303Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ),
        }}
    />
);
